import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations from src/locales
import translationAr from '@/locales/ar/translation.json';
import translationEn from '@/locales/en/translation.json';
import commonAr from '@/locales/ar/common.json';
import commonEn from '@/locales/en/common.json';
import gameAr from '@/locales/ar/game.json';
import gameEn from '@/locales/en/game.json';
import adminAr from '@/locales/ar/admin.json';
import adminEn from '@/locales/en/admin.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: {
        translation: translationAr,
        common: commonAr,
        game: gameAr,
        admin: adminAr,
      },
      en: {
        translation: translationEn,
        common: commonEn,
        game: gameEn,
        admin: adminEn,
      },
    },
    lng: 'ar', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
